module.exports = __webpack_public_path__ + "img/supplier-form-bg.2c3159b.png";